import { AccountDropdownV6Component } from '../../dashboard/breadcrumb/components/account-dropdown-v6/account-dropdown-v6.component';
import { BreadcrumbAnchorComponent } from '../../dashboard/breadcrumb/components/breadcrumb-anchor/breadcrumb-anchor.component';
import { BreadcrumbDrawerComponent } from '../../dashboard/breadcrumb/components/breadcrumb-drawer/breadcrumb-drawer.component';
import { BreadcrumbItemComponent } from '../../dashboard/breadcrumb/components/breadcrumb-item/breadcrumb-item.component';
import { BreadcrumbNavigatorComponent } from '../../dashboard/breadcrumb/components/breadcrumb-navigator/breadcrumb-navigator.component';
import { BreadcrumbSettingsComponent } from '../../dashboard/breadcrumb/components/breadcrumb-settings/breadcrumb-settings.component';
import { BreadcrumbToggleComponent } from '../../dashboard/breadcrumb/components/breadcrumb-toggle/breadcrumb-toggle.component';
import { BreadcrumbComponent } from '../../dashboard/breadcrumb/components/breadcrumb.component';
import { ContentComponent } from '../../dashboard/content/components/content.component';
import { LayoutComponent } from '../../dashboard/layout/components/layout.component';
import { NavCardComponent } from '../../dashboard/navigation/components/nav-card/nav-card.component';
import { NavItemComponent } from '../../dashboard/navigation/components/nav-item/nav-item.component';
import { NavLinkComponent } from '../../dashboard/navigation/components/nav-link/nav-link.component';
import { NavigationComponent } from '../../dashboard/navigation/components/navigation.component';
import { PrintableReportItemComponent } from '../../dashboard/navigation/components/printable-report-item/printable-report-item-r1.component';
import { PartnerInfoComponent } from '../../dashboard/navigation/components/partner-info/partner-info.component';
import { PartnerLogoComponent } from '../../dashboard/navigation/components/partner-logo/partner-logo.component';
import { WidgetLibraryComponent } from '../../widget-library/components/widget-library.component';
import { AccordionGroupComponent } from '../../widget-library/widgets/accordion/accordion-group/accordion-group.component';
import { AccordionComponent } from '../../widget-library/widgets/accordion/accordion.component';
import { BaseWidgetComponent } from '../../widget-library/widgets/base-widget/base-widget.component';
import { CarouselComponent } from '../../widget-library/widgets/carousel/carousel.component';
import { ChartComponent } from '../../widget-library/widgets/chart/chart.component';
import { CreativeCarouselR5Component } from '../../widget-library/widgets/creative-carousel-r5/creative-carousel-r5.component';
import { CreativeCarouselComponent } from '../../widget-library/widgets/creative-carousel/creative-carousel.component';
import { CreativeDetailV2Component } from '../../widget-library/widgets/creative-detail-v2/creative-detail-v2.component';
import { CreativeDetailV7Component } from '../../widget-library/widgets/creative-detail-v7/creative-detail-v7.component';
import { CreativePerformanceV1Component } from '../../widget-library/widgets/creative-performace-v1/creative-performance-v1.component';
import { CreativePerformanceGraphV7Component } from '../../widget-library/widgets/creative-performance-v7/creative-performance-graph-v7/creative-performance-graph-v7.component';
import { CreativePerformanceStatsV7Component } from '../../widget-library/widgets/creative-performance-v7/creative-performance-stats-v7/creative-performance-stats-v7.component';
import { CreativePerformanceV7Component } from '../../widget-library/widgets/creative-performance-v7/creative-performance-v7.component';
import { CreativeR10Component } from '../../widget-library/widgets/creative-r10/creative-r10.component';
import { CreativeR5GraphComponent } from '../../widget-library/widgets/creative-r5-graph/creative-r5-graph.component';
import { CreativesCoxV5Component } from '../../widget-library/widgets/creatives-cox-v5/creatives-cox-v5.component';
import { CreativesR5Component } from '../../widget-library/widgets/creatives-r5/creatives-r5.component';
import { CtvCreativeDetailV2Component } from '../../widget-library/widgets/ctv-creative-detail-v2/ctv-creative-detail-v2.component';
import { CtvCreativeDetailV3Component } from '../../widget-library/widgets/ctv-creative-detail-v3/ctv-creative-detail-v3.component';
import { CtvCreativeDetailV4Component } from '../../widget-library/widgets/ctv-creative-detail-v4/ctv-creative-detail-v4.component';
import { CtvCreativeR1Component } from '../../widget-library/widgets/ctv-creative-r1/ctv-creative-r1.component';
import { CtvCreativeR5Component } from '../../widget-library/widgets/ctv-creative-r5/ctv-creative-r5.component';
import { CtvDaypartR7Component } from '../../widget-library/widgets/ctv-daypart-r7/ctv-daypart-r7.component';
import { CtvDaypartsR1Component } from '../../widget-library/widgets/ctv-dayparts-r1/ctv-dayparts-r1.component';
import { CtvFeaturedNetworksR1Component } from '../../widget-library/widgets/ctv-featured-networks-r1/ctv-featured-networks-r1.component';
import { CtvFeaturedNetworksComponent } from '../../widget-library/widgets/ctv-featured-networks/ctv-featured-networks.component';
import { CtvPerformanceDetailV4Component } from '../../widget-library/widgets/ctv-performance-detail-v4/ctv-performance-detail-v4.component';
import { CtvPlatformPerformanceR3Component } from '../../widget-library/widgets/ctv-platform-performance-r3/ctv-platform-performance-r3.component';
import { CtvPlatformPerformanceComponent } from '../../widget-library/widgets/ctv-platform-performance/ctv-platform-performance.component';
import { CtvQuickstatsR1Component } from '../../widget-library/widgets/ctv-quickstats-r1/ctv-quickstats-r1.component';
import { CtvQuickstatsR7Component } from '../../widget-library/widgets/ctv-quickstats-r7/ctv-quickstats-r7.component';
import { DailyEnagementsV3Component } from '../../widget-library/widgets/daily-enagements-v3/daily-enagements-v3.component';
import { DailyStatsV1Component } from '../../widget-library/widgets/daily-stats-v1/daily-stats-v1.component';
import { DailyStatsComponent } from '../../widget-library/widgets/daily-stats/daily-stats.component';
import { DailymetricsR5Component } from '../../widget-library/widgets/dailymetrics-r5/dailymetrics-r5.component';
import { DataSourceDropdownComponent } from '../../widget-library/widgets/datasource-dropdown/datasource-dropdown.component';
import { DatatableR10Component } from '../../widget-library/widgets/datatable-r10/datatable-r10.component';
import { DatatableV3Component } from '../../widget-library/widgets/datatable-v3/datatable-v3.component';
import { DatatableV4Component } from '../../widget-library/widgets/datatable-v4/datatable-v4.component';
import { DatatableV5Component } from '../../widget-library/widgets/datatable-v5/datatable-v5.component';
import { DataTableComponent } from '../../widget-library/widgets/datatable/datatable.component';
import { DatepickerComponent } from '../../widget-library/widgets/datepicker/datepicker.component';
import { DaypartChartV11Component } from '../../widget-library/widgets/daypart-chart-v11/daypart-chart-v11.component';
import { DaypartChartComponent } from '../../widget-library/widgets/daypart-chart/daypart-chart.component';
import { DaypartDonutComponent } from '../../widget-library/widgets/daypart-donut/daypart-donut.component';
import { DemographicsR11Component } from '../../widget-library/widgets/demographics-r11/demographics-r11.component';
import { DemographicsR7Component } from '../../widget-library/widgets/demographics-r7/demographics-r7.component';
import { DemographicsV5Component } from '../../widget-library/widgets/demographics-v5/demographics-v5.component';
import { DeviceCarouselV1Component } from '../../widget-library/widgets/device-donut-carousel-v1/device-donut-carousel-v1.component';
import { DeviceDonutComponent } from '../../widget-library/widgets/device-donut/device-donut.component';
import { DeviceTableComponent } from '../../widget-library/widgets/device-table/device-table.component';
import { DevicesCardV3Component } from '../../widget-library/widgets/devices-card-v3/devices-card-v3.component';
import { DevicesPlacementsV3Component } from '../../widget-library/widgets/devices-placements-v3/devices-placements-v3.component';
import { DevicesV4Component } from '../../widget-library/widgets/devices-v4/devices-v4.component';
import { EmailDevicesBrowsersV4Component } from '../../widget-library/widgets/email-devices-browsers-v4/email-devices-browsers-v4.component';
import { Devicesr6Component } from '../../widget-library/widgets/devicesr6/devicesr6.component';
import { Devicesr7Component } from '../../widget-library/widgets/devicesr7/devicesr7.component';
import { DisplayCreativeR4Component } from '../../widget-library/widgets/display-creative-r4/display-creative-r4.component';
import { DisplayCreativeR5Component } from '../../widget-library/widgets/display-creative-r5/display-creative-r5.component';
import { DisplayCreativeV3Component } from '../../widget-library/widgets/display-creative-v3/display-creative-v3.component';
import { DisplayCreativeComponent } from '../../widget-library/widgets/display-creative/display-creative.component';
import { DonutComponent } from '../../widget-library/widgets/donut/donut.component';
import { DropdownComponent } from '../../widget-library/widgets/dropdown/dropdown.component';
import { DynamicChartComponent } from '../../widget-library/widgets/dynamic-chart/dynamic-chart.component';
import { EnterpriseReportsGeneratorComponent } from '../../widget-library/widgets/enterprise-reports-generator/enterprise-reports-generator.component';
import { FeaturedNetworksR10Component } from '../../widget-library/widgets/featured-networks-r10/featured-networks-r10.component';
import { GeofenceAppsR6Component } from '../../widget-library/widgets/geofence-apps-r6/geofence-apps-r6.component';
import { GeofenceAppsV3Component } from '../../widget-library/widgets/geofence-apps-v3/geofence-apps-v3.component';
import { GeofenceAppsComponent } from '../../widget-library/widgets/geofence-apps/geofence-apps.component';
import { GeofenceCreativeR4Component } from '../../widget-library/widgets/geofence-creative-r4/geofence-creative-r4.component';
import { LazyDropdownV2Component } from '../../widget-library/widgets/lazy-dropdown-v2/lazy-dropdown-v2.component';
import { LazyDropdownComponent } from '../../widget-library/widgets/lazy-dropdown/lazy-dropdown.component';
import { LiftCardV3Component } from '../../widget-library/widgets/lift-card-v3/lift-card-v3.component';
import { LiftChartComponent } from '../../widget-library/widgets/lift-chart/lift-chart.component';
import { LiftStatsR11Component } from '../../widget-library/widgets/lift-stats-r11/lift-stats-r11.component';
import { LiftStatsR5Component } from '../../widget-library/widgets/lift-stats-r5/lift-stats-r5.component';
import { LiftStatsR7Component } from '../../widget-library/widgets/lift-stats-r7/lift-stats-r7.component';
import { LiftStatsV2Component } from '../../widget-library/widgets/lift-stats-v2/lift-stats-v2.component';
import { LiftStatsComponent } from '../../widget-library/widgets/lift-stats/lift-stats.component';
import { MapOverviewStatsComponent } from '../../widget-library/widgets/map-overview-stats/map-overview-stats.component';
import { MapR10Component } from '../../widget-library/widgets/map-r10/map-r10.component';
import { MapR13Component } from '../../widget-library/widgets/map-r13/map-r13.component';
import { MapV3BetaComponent } from '../../widget-library/widgets/map-v3-beta/map-v3-beta.component';
import { MapV3Component } from '../../widget-library/widgets/map-v3/map-v3.component';
import { MapV4Component } from '../../widget-library/widgets/map-v4/map-v4.component';
import { MapV5BetaComponent } from '../../widget-library/widgets/map-v5-beta/map-v5-beta.component';
import { MapV5Component } from '../../widget-library/widgets/map-v5/map-v5.component';
import { MapV6Component } from '../../widget-library/widgets/map-v6/map-v6.component';
import { MapV7Component } from '../../widget-library/widgets/map-v7/map-v7.component';
import { MapComponent } from '../../widget-library/widgets/map/map.component';
import { MarketronAudioCreativeComponent } from '../../widget-library/widgets/marketron-audio-creative/marketron-audio-creative.component';
import { MarketronDisplayCreativeComponent } from '../../widget-library/widgets/marketron-display-creative/marketron-display-creative.component';
import { MarketronMapComponent } from '../../widget-library/widgets/marketron-map/marketron-map.component';
import { MarketronPrerollCreativeComponent } from '../../widget-library/widgets/marketron-preroll-creative/marketron-preroll-creative.component';
import { NavTabComponent } from '../../widget-library/widgets/nav-tab/nav-tab.component';
import { NavigateToDefaultRouteComponent } from '../../widget-library/widgets/navigate-to-default-route/navigate-to-default-route.component';
import { NavigationCarouselComponent } from '../../widget-library/widgets/navigation-carousel/navigation-carousel.component';
import { NetworkAndShowsR5Component } from '../../widget-library/widgets/network-and-shows-r5/network-and-shows-r5.component';
import { NgxDateRangePickerInlineComponent } from '../../widget-library/widgets/ngx-date-range-picker-inline/ngx-date-range-picker-inline.component';
import { NgxDateRangePickerComponent } from '../../widget-library/widgets/ngx-date-range-picker/ngx-date-range-picker.component';
import { OverviewR3StatsComponent } from '../../widget-library/widgets/overview-r3-stats/overview-r3-stats.component';
import { OverviewSummaryComponentR7 } from '../../widget-library/widgets/overview-summary-r7/overview-summary-r7.component';
import { OverviewSummaryComponent } from '../../widget-library/widgets/overview-summary/overview-summary.component';
import { PartnerNameComponent } from '../../widget-library/widgets/partner-name/partner-name.component';
import { PerformaceCreativeV6Component } from '../../widget-library/widgets/performace-creative-v6/performace-creative-v6.component';
import { PerformanceByDayDisplayV6Component } from '../../widget-library/widgets/performance-by-day-display-v6/performance-by-day-display-v6.component';
import { PlacementsV4Component } from '../../widget-library/widgets/placements-v4/placements-v4.component';
import { PlacementsComponent } from '../../widget-library/widgets/placements/placements.component';
import { PrerollCreativeR5Component } from '../../widget-library/widgets/preroll-creative-r5/preroll-creative-r5.component';
import { PrerollCreativeV3Component } from '../../widget-library/widgets/preroll-creative-v3/preroll-creative-v3.component';
import { PrerollCreativeV4Component } from '../../widget-library/widgets/preroll-creative-v4/preroll-creative-v4.component';
import { PrerollCreativeComponent } from '../../widget-library/widgets/preroll-creative/preroll-creative.component';
import { PrerollQuickStatsComponent } from '../../widget-library/widgets/preroll-quick-stats/preroll-quick-stats.component';
import { CustomProgressBarComponent } from '../../widget-library/widgets/presentational/custom-progress-bar/custom-progress-bar.component';
import { CustomVideoPlayerComponent } from '../../widget-library/widgets/presentational/custom-video-player/custom-video-player.component';
import { UiKitChartComponent } from '../../widget-library/widgets/presentational/generic-chart/generic-chart.component';
import { PrintableReportComponentR1 } from '../../widget-library/widgets/printable-report-r1/printable-report-r1.component';
import { PrintableReportComponent } from '../../widget-library/widgets/printable-report/printable-report.component';
import { ProductCsvDownloadComponent } from '../../widget-library/widgets/product-csv-download/product-csv-download.component';
import { ProductDownloadR10Component } from '../../widget-library/widgets/product-download-r10/product-download-r10.component';
import { ProductLiftChartR10Component } from '../../widget-library/widgets/product-lift-chart-r10/product-lift-chart-r10.component';
import { ProductLiftChartR11Component } from '../../widget-library/widgets/product-lift-chart-r11/product-lift-chart-r11.component';
import { ProductLiftChartR5Component } from '../../widget-library/widgets/product-lift-chart-r5/product-lift-chart-r5.component';
import { ProductLiftChartR7Component } from '../../widget-library/widgets/product-lift-chart-r7/product-lift-chart-r7.component';
import { ProductLiftChartComponent } from '../../widget-library/widgets/product-lift-chart/product-lift-chart.component';
import { ProductLiftTableComponent } from '../../widget-library/widgets/product-lift-table/product-lift-table.component';
import { ProductOverviewR10Component } from '../../widget-library/widgets/product-overview-r10/product-overview-r10.component';
import { QuickStatsR10Component } from '../../widget-library/widgets/quick-stats-r10/quick-stats-r10.component';
import { QuickStatsR5Component } from '../../widget-library/widgets/quick-stats-r5/quick-stats-r5.component';
import { QuickStatsComponent } from '../../widget-library/widgets/quick-stats/quick-stats.component';
import { R3ConversionsComponent } from '../../widget-library/widgets/r3-conversions/r3-conversions.component';
import { R10DaypartComponent } from '../../widget-library/widgets/r10-daypart/r10-daypart.component';
import { R10DemographicsComponent } from '../../widget-library/widgets/r10-demographics/r10-demographics.component';
import { R10DevicesComponent } from '../../widget-library/widgets/r10-devices/r10-devices.component';
import { R10PlatformPerformanceComponent } from '../../widget-library/widgets/r10-platform-performance/r10-platform-performance.component';
import { R4MapOverviewStatsComponent } from '../../widget-library/widgets/r4-map-overview-stats/r4-map-overview-stats.component';
import { R5CalendarClose } from '../../widget-library/widgets/r5-calendar-close/r5-calendar-close.component';
import { R5DevicesComponent } from '../../widget-library/widgets/r5-devices/r5-devices.component';
import { R6DaypartComponent } from '../../widget-library/widgets/r6-daypart/r6-daypart.component';
import { R6MapOverviewStatsComponent } from '../../widget-library/widgets/r6-map-overview-stats/r6-map-overview-stats.component';
import { R6MarketronMapComponent } from '../../widget-library/widgets/r6-marketron-map/r6-marketron-map.component';
import { R7LiftHistogramComponent } from '../../widget-library/widgets/r7-lift-histogram/r7-lift-histogram.component';
import { RadioCreativeR1Component } from '../../widget-library/widgets/radio-creative-r1/radio-creative-r1.component';
import { ScatterPlotChartComponent } from '../../widget-library/widgets/scatter-plot-chart/scatter-plot-chart.component';
import { ScreenshotsR10Component } from '../../widget-library/widgets/screenshots-r10/screenshots-r10.component';
import { ScreenshotsR11Component } from '../../widget-library/widgets/screenshots-r11/screenshots-r11.component';
import { ScreenshotsR5Component } from '../../widget-library/widgets/screenshots-r5/screenshots-r5.component';
import { ScreenshotsComponent } from '../../widget-library/widgets/screenshots/screenshots.component';
import { SectionCarouselItemComponent } from '../../widget-library/widgets/section-carousel/section-carousel-item/section-carousel-item.component';
import { SectionCarouselComponent } from '../../widget-library/widgets/section-carousel/section-carousel.component';
import { SemCallsR10Component } from '../../widget-library/widgets/sem-calls-r10/sem-calls-r10.component';
import { SemCallsR11Component } from '../../widget-library/widgets/sem-calls-r11/sem-calls-r11.component';
import { SemCallsR5Component } from '../../widget-library/widgets/sem-calls-r5/sem-calls-r5.component';
import { SemCallsV1Component } from '../../widget-library/widgets/sem-calls-v1/sem-calls-v1.component';
import { SemCallsV2Component } from '../../widget-library/widgets/sem-calls-v2/sem-calls-v2.component';
import { SemCallsV3Component } from '../../widget-library/widgets/sem-calls-v3/sem-calls-v3.component';
import { SemCallsV4Component } from '../../widget-library/widgets/sem-calls-v4/sem-calls-v4.component';
import { SemCallsV5Component } from '../../widget-library/widgets/sem-calls-v5/sem-calls-v5.component';
import { SemCallsV6Component } from '../../widget-library/widgets/sem-calls-v6/sem-calls-v6.component';
import { SemCreativeCardV1Component } from '../../widget-library/widgets/sem-creative-card-v1/sem-creative-card-v1.component';
import { SemCreativeCardV2Component } from '../../widget-library/widgets/sem-creative-card-v2/sem-creative-card-v2.component';
import { SemCreativeCardV3Component } from '../../widget-library/widgets/sem-creative-card-v3/sem-creative-card-v3.component';
import { SemCreativeCardV4Component } from '../../widget-library/widgets/sem-creative-card-v4/sem-creative-card-v4.component';
import { SemCreativeCoxV5Component } from '../../widget-library/widgets/sem-creative-cox-v5/sem-creative-cox-v5.component';
import { SemCreativeV7Component } from '../../widget-library/widgets/sem-creative-v7/sem-creative-v7.component';
import { SemKeywordsR10Component } from '../../widget-library/widgets/sem-keywords-r10/sem-keywords-r10.component';
import { SemKeywordsV1Component } from '../../widget-library/widgets/sem-keywords-v1/sem-keywords-v1.component';
import { SemKeywordsV4Component } from '../../widget-library/widgets/sem-keywords-v4/sem-keywords-v4.component';
import { SemKeywordsV5Component } from '../../widget-library/widgets/sem-keywords-v5/sem-keywords-v5.component';
import { SemQuickStatsV7Component } from '../../widget-library/widgets/sem-quick-stats-v7/sem-quick-stats-v7.component';
import { SemQuickStatsComponent } from '../../widget-library/widgets/sem-quick-stats/sem-quick-stats.component';
import { SingleStatComponent } from '../../widget-library/widgets/single-stat/single-stat.component';
import { SocialDemographicsR1Component } from '../../widget-library/widgets/social-demographics-r1/social-demographics-r1.component';
import { SocialDemographicsR2Component } from '../../widget-library/widgets/social-demographics-r2/social-demographics-r2.component';
import { SocialDemographicsV3Component } from '../../widget-library/widgets/social-demographics-v3/social-demographics-v3.component';
import { SocialDemographicsV4Component } from '../../widget-library/widgets/social-demographics-v4/social-demographics-v4.component';
import { SocialDemographicsV6Component } from '../../widget-library/widgets/social-demographics-v6/social-demographics-v6.component';
import { SolidgaugeDonutComponent } from '../../widget-library/widgets/solidgauge-donut/solidgauge-donut.component';
import { SparklineComponent } from '../../widget-library/widgets/sparkline/sparkline.component';
import { StreamingAudioQuickstatsR1Component } from '../../widget-library/widgets/streaming-audio-quickstats-r1/streaming-audio-quickstats-r1.component';
import { SubNavComponent } from '../../widget-library/widgets/sub-nav/sub-nav.component';
import { TableProgressbar } from '../../widget-library/widgets/table-progressbar/table-progressbar.component';
import { TableHorizontalComponent } from '../../widget-library/widgets/table-horizontal/table-horizontal.component';
import { TimelineChartComponent } from '../../widget-library/widgets/timeline-chart/timeline-chart.component';
import { TvDailyMetricsComponent } from '../../widget-library/widgets/tv-daily-metrics/tv-daily-metrics.component';
import { TvNetworkProgramV1Component } from '../../widget-library/widgets/tv-network-program-v1/tv-network-program-v1.component';
import { VideoCreativeR7Component } from '../../widget-library/widgets/video-creative-r7/video-creative-r7.component';
import { OutletComponent } from '../components/outlet/outlet.component';
import { PrintableNavComponent } from '../../widget-library/widgets/printable-nav/printable-nav.component';
import { SemCallsR10ReskinComponent } from '../../widget-library/widgets/sem-calls-r10-reskin/sem-calls-r10-reskin.component';
import { LiftChartR10ReskinComponent } from '../../widget-library/widgets/lift-chart-r10-reskin/lift-chart-r10-reskin.component';
import { UniqueReachAndFrequencyR13Component } from '../../widget-library/widgets/unique-reach-and-frequency-r13/unique-reach-and-frequency-r13.component';
import { UniqueReachAndFrequencyComponent } from '../../widget-library/widgets/unique-reach-and-frequency/unique-reach-and-frequency.component';
import { UniqueReachAndFrequencyR3Component } from '../../widget-library/widgets/unique-reach-and-frequency-r3/unique-reach-and-frequency-r3.component';
import { WelcomeUserComponent } from '../../widget-library/welcome-user/welcome-user.component';
import { SemResponsiveSearchAdsComponent } from '../../widget-library/widgets/sem-responsive-search-ads/sem-responsive-search-ads.component';
import { R13SemConversionsComponent } from '../../widget-library/widgets/r13-sem-conversions/r13-sem-conversions.component';
import { R5SemCoversionsComponent } from '../../widget-library/widgets/r5-sem-coversions/r5-sem-coversions.component';
import { Conversionr6Component } from '../../widget-library/widgets/conversionr6/conversionr6.component';
import { CustomDisclaimerComponent } from '../../widget-library/widgets/custom-disclaimer/custom-disclaimer.component';
import { EmailBrowserR13Component } from '../../widget-library/widgets/email-browser-r13/email-browser-r13.component';
import { EmailLinkSummaryR13Component } from '../../widget-library/widgets/email-link-summary-R13/email-link-summary-r13.component';
import { R4ConversionsComponent } from '../../widget-library/widgets/r4-conversions/r4-conversions.component';
import { R10ConversionsComponent } from '../../widget-library/widgets/r10-conversions/r10-conversions.component';
import { R2ConversionsComponent } from '../../widget-library/widgets/r2-conversions/r2-conversions.component';
import { R1SemConversionsComponent } from '../../widget-library/widgets/r1-sem-conversions/r1-sem-conversions.component';
import { R7SemConversionsComponent } from '../../widget-library/widgets/r7-sem-conversions/r7-sem-conversions.component';
import { LineItemsComponent } from '../../widget-library/widgets/line-items/line-items.component';
import { SemAdAssetsComponent } from '../../widget-library/widgets/sem-ad-assets/sem-ad-assets.component';
import { R103TimeOfTheDayComponent } from '../../widget-library/widgets/r103-time-of-the-day/r103-time-of-the-day.component';
import { R1301OverviewDevicesComponent } from '../../widget-library/widgets/r1301-overview-devices/r1301-overview-devices.component';
import { CtvDaypartsComponent } from '../../widget-library/widgets/ctv-dayparts/ctv-dayparts.component';
import { VenueTypeComponent } from '../../widget-library/widgets/venue-type/venue-type.component';

export const CUSTOM_COMPONENTS = [
	OutletComponent,
	NavigationComponent,
	NavItemComponent,
	NavLinkComponent,
	PartnerInfoComponent,
	PartnerLogoComponent,
	BreadcrumbComponent,
	BreadcrumbItemComponent,
	BreadcrumbAnchorComponent,
	BreadcrumbToggleComponent,
	BreadcrumbNavigatorComponent,
	ContentComponent,
	LayoutComponent,
	WidgetLibraryComponent,
	QuickStatsComponent,
	SingleStatComponent,
	PrerollQuickStatsComponent,
	CtvQuickstatsR1Component,
	CtvQuickstatsR7Component,
	CtvCreativeR1Component,
	SemQuickStatsComponent,
	SemQuickStatsV7Component,
	LiftStatsComponent,
	LiftStatsR7Component,
	LiftStatsV2Component,
	SparklineComponent,
	DonutComponent,
	DeviceTableComponent,
	OverviewSummaryComponent,
	OverviewSummaryComponentR7,
	CarouselComponent,
	DatepickerComponent,
	DropdownComponent,
	CreativeCarouselComponent,
	LiftChartComponent,
	ChartComponent,
	ProductLiftChartComponent,
	ProductLiftChartR7Component,
	ProductLiftChartR10Component,
	ProductLiftChartR5Component,
	TableHorizontalComponent,
	ProductLiftTableComponent,
	MapComponent,
	DisplayCreativeComponent,
	PlacementsComponent,
	DisplayCreativeR5Component,
	ScreenshotsComponent,
	PrerollCreativeComponent,
	PartnerNameComponent,
	MarketronMapComponent,
	MapOverviewStatsComponent,
	DailyStatsComponent,
	GeofenceAppsComponent,
	AccordionComponent,
	AccordionGroupComponent,
	MarketronDisplayCreativeComponent,
	MarketronPrerollCreativeComponent,
	CreativeDetailV2Component,
	DataTableComponent,
	DailyStatsV1Component,
	ProductCsvDownloadComponent,
	CreativePerformanceV1Component,
	SemKeywordsV1Component,
	SemCallsV1Component,
	SemCallsV2Component,
	SemCallsV6Component,
	DeviceCarouselV1Component,
	DeviceDonutComponent,
	DynamicChartComponent,
	SemCreativeCardV1Component,
	SemCreativeCardV2Component,
	SubNavComponent,
	DevicesCardV3Component,
	LiftCardV3Component,
	DisplayCreativeV3Component,
	PrerollCreativeV3Component,
	OverviewR3StatsComponent,
	MapV3Component,
	MapV3BetaComponent,
	DatatableV3Component,
	DailyEnagementsV3Component,
	DevicesPlacementsV3Component,
	SectionCarouselComponent,
	SectionCarouselItemComponent,
	SemCallsV3Component,
	SemCreativeCardV3Component,
	EnterpriseReportsGeneratorComponent,
	CtvFeaturedNetworksComponent,
	CtvPlatformPerformanceComponent,
	CtvCreativeDetailV2Component,
	CtvCreativeDetailV3Component,
	LazyDropdownComponent,
	GeofenceAppsV3Component,
	GeofenceCreativeR4Component,
	CtvFeaturedNetworksR1Component,
	NavigationCarouselComponent,
	DisplayCreativeR4Component,
	MapV4Component,
	MapV5Component,
	DatatableV4Component,
	PrerollCreativeV4Component,
	PlacementsV4Component,
	CtvCreativeDetailV4Component,
	SemKeywordsV4Component,
	SemCallsV4Component,
	DevicesV4Component,
	EmailDevicesBrowsersV4Component,
	SemCreativeCardV4Component,
	CtvPlatformPerformanceR3Component,
	DataSourceDropdownComponent,
	QuickStatsR5Component,
	R5CalendarClose,
	CreativesR5Component,
	CreativeR5GraphComponent,
	DailymetricsR5Component,
	LiftStatsR5Component,
	CreativeR5GraphComponent,
	NetworkAndShowsR5Component,
	SemKeywordsV5Component,
	DatatableV5Component,
	R5DevicesComponent,
	SocialDemographicsR2Component,
	SocialDemographicsR1Component,
	CreativesCoxV5Component,
	SemCreativeCoxV5Component,
	DaypartChartComponent,
	TvDailyMetricsComponent,
	SemCallsR5Component,
	SocialDemographicsV3Component,
	SocialDemographicsV4Component,
	NgxDateRangePickerComponent,
	BreadcrumbSettingsComponent,
	ScreenshotsR5Component,
	DemographicsV5Component,
	CreativeCarouselR5Component,
	PrerollCreativeR5Component,
	CtvCreativeR5Component,
	SocialDemographicsV6Component,
	NgxDateRangePickerComponent,
	PerformanceByDayDisplayV6Component,
	PerformaceCreativeV6Component,
	Devicesr6Component,
	Conversionr6Component,
	SolidgaugeDonutComponent,
	GeofenceAppsR6Component,
	R6MapOverviewStatsComponent,
	R6MarketronMapComponent,
	AccountDropdownV6Component,
	MapV5BetaComponent,
	R4MapOverviewStatsComponent,
	PrintableReportComponent,
	PrintableReportComponentR1,
	DaypartDonutComponent,
	CtvPerformanceDetailV4Component,
	DemographicsR7Component,
	CreativePerformanceV7Component,
	CreativePerformanceStatsV7Component,
	CreativePerformanceGraphV7Component,
	CreativeDetailV7Component,
	SemCreativeV7Component,
	VideoCreativeR7Component,
	MapV7Component,
	R7LiftHistogramComponent,
	Devicesr7Component,
	CtvDaypartR7Component,
	TvNetworkProgramV1Component,
	CtvDaypartsR1Component,
	ScatterPlotChartComponent,
	SemCallsV5Component,
	MapV6Component,
	DemographicsR11Component,
	SemCallsR11Component,
	R6DaypartComponent,
	NavCardComponent,
	DaypartChartV11Component,
	NavTabComponent,
	ScreenshotsR10Component,
	ScreenshotsR11Component,
	ProductLiftChartR11Component,
	LiftStatsR11Component,
	ProductOverviewR10Component,
	LazyDropdownV2Component,
	BreadcrumbDrawerComponent,
	NgxDateRangePickerInlineComponent,
	BaseWidgetComponent,
	R10DemographicsComponent,
	R10PlatformPerformanceComponent,
	MapR10Component,
	CreativeR10Component,
	CustomVideoPlayerComponent,
	CustomProgressBarComponent,
	FeaturedNetworksR10Component,
	QuickStatsR10Component,
	UiKitChartComponent,
	SemCallsR10Component,
	SemKeywordsR10Component,
	DatatableR10Component,
	R10DevicesComponent,
	R3ConversionsComponent,
	R10DaypartComponent,
	TimelineChartComponent,
	MapR13Component,
	RadioCreativeR1Component,
	StreamingAudioQuickstatsR1Component,
	TableProgressbar,
	PrintableNavComponent,
	MarketronAudioCreativeComponent,
	PrintableReportItemComponent,
	SemCallsR10ReskinComponent,
	LiftChartR10ReskinComponent,
	ProductDownloadR10Component,
	UniqueReachAndFrequencyR13Component,
	UniqueReachAndFrequencyComponent,
	UniqueReachAndFrequencyR3Component,
	WelcomeUserComponent,
	NavigateToDefaultRouteComponent,
	SemResponsiveSearchAdsComponent,
	R13SemConversionsComponent,
	R5SemCoversionsComponent,
	CustomDisclaimerComponent,
	EmailBrowserR13Component,
	EmailLinkSummaryR13Component,
	R4ConversionsComponent,
	R10ConversionsComponent,
	R2ConversionsComponent,
	R1SemConversionsComponent,
	R7SemConversionsComponent,
	LineItemsComponent,
	SemAdAssetsComponent,
	R1301OverviewDevicesComponent,
	CtvDaypartsComponent,
	R103TimeOfTheDayComponent,
	VenueTypeComponent
];
